import React, { useState } from 'react';
import Styles from './faq.module.scss';
import Plus from '../../assets/images/faq/plus-circle.svg';
import Minus from '../../assets/images/faq/minus-circle.svg';

const faqItems = [
  {
    question: 'What is Liquidity-Staking?',
    answer:
      'MLT/BNB Liquidy staking enables users to stake their Cake LP-Tokens for rewards in MLT. ',
  },
  {
    question: 'How does Liquidity-Staking for MLT/BNB work?',
    answer:
      'As a first step users have to provide liquidity to the MLT/BNB Trading Pool on Pancakeswap in order to get LP-Tokens. <br /><br />To learn how this works, kindly follow this link and scroll to “Exchange V2”: \nhttps://docs.pancakeswap.finance/products/pancakeswap-exchange/liquidity-guide      ',
  },
  {
    question: 'What is an LP-Token?',
    answer:
      '(Liquidity Pool or Liquidity Provider token ) Also called "pool tokens" and "liquidity tokens," an LP token is a crypto token given to users who loan their crypto to a liquidity pool.',
  },
  {
    question: 'What are the benefits of Liquidity-Staking for MLT/BNB?',
    answer:
      'Liquidity Staking is like a bet on both associated assets, in this case MLT and BNB. If you are bullish on both assets you can substantially earn on them by speculating on a positive price movement. While doing this you can earn APR on your staked LP-Tokens in form of MLT. Thereby APR percentage is measured by USD and stays flexible. Average APR Percentage depends on a) number of stakers overall, b) Total amount staked in USD and c) Available MLT rewards pool.  ',
  },
  {
    question: 'What are the risks of Liquidity-Staking for MLT/BNB?',
    answer:
      'In general Liquidity Staking is executed automatically by Smart Contracts. To engage with the Staking Platform Smart Contracts you need to access them by connecting your self-custody wallet. Before connecting your wallet to this platform ALWAYS check if the URL is correct! ALWAYS check the associated Smart Contracts before approving a transaction! \nPlease be aware that this Staking Platform is an online interface. We made sure to keep it as safe as possible but theoretically there is always exploitation risk that couldn’t have been foreseen beforehand. Hence you are staking your assets ON YOUR OWN RISK! Apart from technical and exploitation risk, there can occure economical risk due to impermanent loss. <br /><br />To learn more about it, kindly follow this link: https://medium.com/omniaprotocol/what-is-impermanent-loss-and-how-can-it-be-minimized-fe31d390379e',
  },
  {
    question: 'Where can I verify the Smart Contracts associated to Liquidity-Staking for MLT/BNB?',
    answer:
      '• MLT/BNB Trading Pool: \nhttps://bscscan.com/address/0x66fe9c4e1260386483bf91cb7106e75ba5d91a60 <br /><br />• MLT/BNB Liquidity Token:\n https://bscscan.com/token/0x66fe9c4e1260386483bf91cb7106e75ba5d91a60 <br /><br />• MLT/BNB Staking Pool: \nhttps://bscscan.com/token/0x5831778dFF002c4808c62f541Fa8d61D0bBc3F18 <br /><br />• BEP20 MLT: \nhttps://bscscan.com/address/0xB72a20C7B8BD666f80AC053B0f4de20a787080F5 <br /><br />\nMake sure to ALWAYS double check via official sources!',
  },
];
const Faq = () => {
  const [isOpen, setIsOpen] = useState(Array.from({ length: faqItems.length }, () => false));

  const toggleAnswer = (index) => {
    const newIsOpen = [...isOpen];
    newIsOpen[index] = !newIsOpen[index];
    setIsOpen(newIsOpen);
  };

  return (
    <div className={Styles.faqMain}>
      <div className={Styles.faqText}>FAQ</div>
      {faqItems.map((item, index) => (
        <div key={index} className={Styles.borderB}>
          <div className={Styles.question} onClick={() => toggleAnswer(index)}>
            {item.question}
            <span className={Styles.icon}>
              {isOpen[index] ? (
                <img src={Minus} alt='Minus Icon' />
              ) : (
                <img src={Plus} alt='Plus Icon' />
              )}
            </span>
          </div>
          <div
            className={`${Styles.answer} ${isOpen[index] ? Styles.open : ''}`}
            dangerouslySetInnerHTML={{ __html: item.answer }}
          />
        </div>
      ))}
    </div>
  );
};
export default React.memo(Faq);
